import React from "react";
import { Col } from "react-bootstrap";

export const RemoveButton = props => {
  const { fields, index } = props;

  return (
    <Col xs={1}>
      <button
        type="button"
        title="Remove"
        onClick={() => {
          let field = fields.get(index);
          field.remove = true;
          fields.push({ remove: true });
        }}
        style={{
          border: 0,
          backgroundColor: "transparent",
          padding: 0,
          marginTop: 11
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          style={{ margin: "5px" }}
        >
          <path
            fill="none"
            fillRule="evenodd"
            stroke="#70ADCC"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M8.999 1A7.997 7.997 0 0 0 1 8.999 8.001 8.001 0 1 0 8.999 1zm0 0v0M4.362 9h9.277"
          />
        </svg>
      </button>
    </Col>
  );
};



// WEBPACK FOOTER //
// ./src/routes/candidate/completeProfile/components/AddBox/RemoveButton.js